//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from 'vuex';

export default {
  props: {
    isLoading: { type: Boolean, default: false },
  },

  data() {
    return {
      localAppName: '',
      filters: {
        appName: '',
        keyId: '',
        dateFrom: '',
        dateTo: '',
        status: '',
      },
    };
  },

  mounted() {
    const { key } = this.$route.query;

    if (key) {
      this.$router.replace({ query: {} });
      this.filters = {
        ...this.filters,
        keyId: key,
      };
    } else {
      this.loadData();
    }
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapState('apiKeys', ['filterLists']),

    activeList() {
      return [
        {
          id: 'true',
          caption: 'Enabled',
        },
        {
          id: 'false',
          caption: 'Disabled',
        },
      ];
    },
  },

  watch: {
    filters: {
      async handler(data) {
        await this.setFilters(data);
        this.$emit('update');
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('apiKeys', ['setFilters', 'loadData']),

    handleAppNameBlur() {
      this.filters.appName = this.localAppName;
    },

    handleKeyIdBlur() {
      this.filters.keyId = this.localKeyId;
    },
  },
};
